import { render } from "./NewBindStudent.vue?vue&type=template&id=71486b45"
import script from "./NewBindStudent.vue?vue&type=script&lang=js"
export * from "./NewBindStudent.vue?vue&type=script&lang=js"

import "./NewBindStudent.vue?vue&type=style&index=0&id=71486b45&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__